import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateRestaurantSearchKey, updateRestaurantList } from "../../redux/actions/restaurantActions";
import { useLocation, useNavigate } from "react-router-dom";
import Auth from "../../auth/Auth";
import useCurrentPosition from "../../helpers/customHooks/useCurrentPosition";
import {
  updateFullScreenLoader,
  updateOnboardingState,
} from "../../redux/actions/authActions";
import { http } from "../../helpers/http";


function SearchField(props) {
  const state = useSelector((state) => state.auth);
  const searchKey = useSelector((state) => state.restaurant.searchKey);
  console.log(searchKey, "searchKey12")
  const { latitudeData, longitudeData, timezone } = useCurrentPosition();
  const [seachValue, setSeachValue] = useState();
  const [newLoc, setNewLoc] = useState()
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const searchRestData = (search) => {
    // dispatch(updateFullScreenLoader(true));
    const requestBody = {
      latitude: latitudeData,
      longitude: longitudeData,
      type: "Take Out",
      timezone: timezone,
      restaurantName: search
    };
    http(
      {
        method: "POST",
        url: `searchRestaurants`,
        isSecure: true,
        body: requestBody
      },
      (res) => {
        dispatch(updateRestaurantList(res.error === "false" ? res : {}));
        dispatch(updateFullScreenLoader(false));
      }
    );

  };

  const submitHandler = (data) => {
    const trimmedSearchKey = data.trim();
    dispatch(updateRestaurantSearchKey(trimmedSearchKey));

    if (trimmedSearchKey === "") {
      dispatch(updateRestaurantList([]));
    } else {
      // searchRestData(trimmedSearchKey);
    }
  };
  return (
    <>
      {
        !state.isUserloggedIn ? (
          pathname === "/" ?

            <div className="inputGroup inputmain-banner ms-lg-2">
              {/* <!-- <span className="input-filltxt-show">Burger</span> --> */}
              <input
                type="text"
                className="input_control input-inside-img bg-white"
                placeholder="Search Restaurant..."
                value={searchKey}
                // onChange={(e) => dispatch(updateRestaurantSearchKey(e.target.value))}
                onChange={(e) => {
                  searchRestData(e.target.value);
                  console.log(e.target.value, ';;;;;');
                  dispatch(updateRestaurantSearchKey(e.target.value));
                  submitHandler(e.target.value); // Call submitHandler on input change
                }}
              />
            </div>



            : ""
        ) : ""
      }


    </>

  );
}

export default SearchField;
